<!--<p>message-box-header works!</p>-->
<div style="width: 450px;">
<h2 mat-dialog-title >{{headerMessage}}</h2>
<mat-dialog-content [innerHTML]="message" class="mat-content-message"></mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close class="button-design">OK</button>
</mat-dialog-actions>
</div>